import { greenlandPostalCodes } from "@/data/postal-codes";
import { api } from "@/utils/api";
import { queryOptions, useQuery } from "@tanstack/react-query";

type PostalCodeResponse = {
  nr: string;
  navn: string;
};

const postalCodesQueryOptions = queryOptions({
  queryKey: ["postalCodes"],
  queryFn: async () => {
    const response = await api
      .get("data/dagi/postalcodes")
      .json<PostalCodeResponse[]>();

    // An empty list would otherwise render as only the Greenland codes below.
    if (!Array.isArray(response) || response.length === 0) {
      throw new Error("Postal codes endpoint returned no postal codes");
    }

    return response;
  },
  select: (data) =>
    data
      .map((c: PostalCodeResponse) => ({
        title: `${c.nr} ${c.navn}`,
        value: +c.nr,
      }))
      .concat(greenlandPostalCodes),
});

export function usePostalCodes() {
  return useQuery(postalCodesQueryOptions);
}
